import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

if (environment.production) {
  enableProdMode();
}

// Initialize CloudWatch RUM
if ((environment as any).rum) {
  try {
    const rumConfig = (environment as any).rum;
    const config: AwsRumConfig = {
      allowCookies: true,
      enableXRay: rumConfig.enable_xray,
      sessionSampleRate: rumConfig.session_sample_rate,
      signing: rumConfig.signing ?? true,
      telemetries: ['errors', 'performance', 'http'],
      ...((rumConfig.signing ?? true) ? { identityPoolId: rumConfig.identity_pool_id } : {}),
      ...(rumConfig.endpoint ? { endpoint: rumConfig.endpoint } : {}),
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const awsRum: AwsRum = new AwsRum(
      rumConfig.app_monitor_id,
      environment.version,
      rumConfig.region,
      config
    );
  } catch {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));